import Header from "@/components/Header";
import M365Ladder from "@/components/M365Ladder";
import TrustStats from "@/components/TrustStats";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import OrganizationSchema from "@/components/seo/OrganizationSchema";


const Index = () => {
  return (
    <div className="min-h-screen">
      <OrganizationSchema />
      <Header />
      <M365Ladder />
      <TrustStats />
      <Contact className="pt-[50px]" />
      <Footer />
    </div>
  );
};

export default Index;